import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';
import { RouterLink } from '@angular/router';

import { LogoComponent } from '../../../../../ui-kit/logo/logo.component';

@Component({
  selector: 'app-landing-header',
  templateUrl: './landing-header.component.html',
  styleUrls: ['./landing-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatToolbarModule, MatButtonModule, MatMenuModule, MatIconModule, RouterLink, LogoComponent],
})
export class LandingHeaderComponent {}
